import React, { useState } from 'react';
import {
  ChevronDownIcon,
  ChevronRightIcon,
} from '../../assets/svg/SVGComponents';

import { Container, AccordionHeader, AccordionContent } from './styles';

interface AccordionProps {
  title: string;
  open: boolean;
  children: React.ReactNode;
}

const AccordionProfile: React.FC<AccordionProps> = ({
  title,
  children,
  open = false,
}) => {
  const [isOpen, setIsOpen] = useState(open);

  return (
    <Container>
      <AccordionHeader type="button" onClick={() => setIsOpen(!isOpen)}>
        <div>
          <h4>{title} </h4>
          <ChevronDownIcon className={isOpen ? 'open' : ''} />
        </div>
      </AccordionHeader>
      <AccordionContent className={!isOpen ? 'collapsed' : ''}>
        {children}
      </AccordionContent>
    </Container>
  );
};

export default AccordionProfile;
